import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreateLegalDocumentRequestBody,
  IApiCreateLegalDocumentResponseBody,
  IApiDeleteLegalDocumentResponseBody,
  IApiGetLegalDocumentResponseBody,
  IApiGetLegalDocumentsResponseBody,
  IApiUpdateLegalDocumentRequestBody,
  IApiUpdateLegalDocumentResponseBody,
} from './LegalDocumentsApi.types';

export class LegalDocumentsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
  ): Promise<IApiGetLegalDocumentsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/legal',
      method: 'get',
    };

    const data =
      await this.client.fetchJsonStandardized<IApiGetLegalDocumentsResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async get(
    appId: string,
    legalDocumentId: string,
  ): Promise<IApiGetLegalDocumentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/legal/${legalDocumentId}`,
      method: 'get',
    };

    const data =
      await this.client.fetchJsonStandardized<IApiGetLegalDocumentResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async create(
    appId: string,
    body: IApiCreateLegalDocumentRequestBody,
  ): Promise<IApiCreateLegalDocumentResponseBody> {
    const request: IApiJsonRequest = {
      path: '/legal',
      method: 'post',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCreateLegalDocumentResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async update(
    appId: string,
    legalDocumentId: string,
    body: IApiUpdateLegalDocumentRequestBody,
  ): Promise<IApiUpdateLegalDocumentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/legal/${legalDocumentId}`,
      method: 'patch',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiUpdateLegalDocumentResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async delete(
    appId: string,
    legalDocumentId: string,
  ): Promise<IApiDeleteLegalDocumentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/legal/${legalDocumentId}`,
      method: 'delete',
    };

    const data =
      await this.client.fetchJsonStandardized<IApiDeleteLegalDocumentResponseBody>(
        request,
        { appId },
      );

    return data;
  }
}
